module.exports = __webpack_public_path__ + "static/media/teacher-svgrepo-com 1.6d30e691.webp";